﻿window.applicationlogbook = function () {

    function upgradeLogType(applLogId) {

        $.ajax({
            type: "POST",
            url: appsettings.getUrl("ApplicationLogBook/Upgrade?applLogId=" + applLogId),
            success: function (responseData) {

                if (responseData != undefined && responseData != null) {
                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    }
                }

                var grid = $("#ApplicationLogBookGrid").data("kendoGrid");
                grid.dataSource.read();
            }
        });

    }

    return {

        initialize: function () {
        },

        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // dataItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Show mode form 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("ApplicationLogBook/Show?applLogId=" + dataItem.ApplLogID + "&breadcrumbLabel=" + escape(dataItem.Label));
        },

        visibilityItem: function (dataItem) {
            return dataItem.LogType == 1;
        },

        upgradeItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // dataItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            upgradeLogType(dataItem.ApplLogID);
        },

    }

}();